// Build-time flag: Expo inlines EXPO_PUBLIC_* values when bundling, so keep the
// direct `process.env.EXPO_PUBLIC_…` reference.

// "true" adds Mux's report (evt.live /api/analytics) under ours in Event
// Analytics, to compare the two while Mux still runs. Netlify turns it on for
// deploy previews (netlify.toml); production builds leave it off.
export const MUX_REPORT_ENABLED = process.env.EXPO_PUBLIC_MUX_REPORT === "true";

// The switch from Mux's report to ours (logic.js reportSource). Events dated
// from OWN_REPORT_FROM get ours. Events dated before it keep Mux's report, as
// before, until MUX_REPORT_UNTIL; from then on every event shows ours. Set
// OWN_REPORT_FROM after the backend is deployed (docs/viewer-hours.md).
export const OWN_REPORT_FROM = "2026-10-30T00:00:00Z";
export const MUX_REPORT_UNTIL = "2026-11-06T00:00:00Z";
// Mux's report only ever covered events from this day; older ones showed
// basic counts, which our report shows too.
export const MUX_REPORT_EVENTS_FROM = "2025-05-20";
